<template>
  <!-- 无权限 -->
  <div class="box1">
    <img src="../../../assets/imgs/img/geren-SVG/Slice-34.svg" alt="" />
    <p>没有权限查看本页面，请联系管理员</p>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>

<style scoped lang="less">
.box1 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  img{
    margin: auto;
  }
  p{
    font-size: 12px;
    text-align: center;
    margin-top: -150px;
    color: #c1c1c1;
  }
}
</style>
